import { useCallback } from 'react';

import Comment from '@sayyesschool/frontend/components/comment';
import CommentForm from '@sayyesschool/frontend/components/comment-form';
import PageSection from '@sayyesschool/frontend/components/page-section';

import { useCommentsActions } from '@sayyesschool/frontend/features/comments';
import { useUser } from '@sayyesschool/frontend/features/user';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';
import { Button, Flex, Text } from '@sayyesschool/frontend/ui-components';

export default function EnrollmentComments({ enrollment }) {
    const [user] = useUser();
    const actions = useCommentsActions();

    const [isCommenting, toggleCommenting] = useBoolean(false);

    const createComment = useCallback(data => {
        if (!data.content) return;

        data.author = user.id;
        data.ref = enrollment.id;

        return actions.createComment(data)
            .then(() => toggleCommenting(false));
    }, [user, enrollment, actions, toggleCommenting]);

    const updateComment = useCallback((commentId, data) => {
        return actions.updateComment(commentId, data);
    }, [actions]);

    const deleteComment = useCallback(commentId => {
        return actions.deleteComment(commentId);
    }, [actions]);

    return (
        <PageSection
            className="EnrollmentComments"
            title="Комментарии"
            actions={!isCommenting && [{
                key: 'add',
                icon: 'add',
                size: 'sm',
                onClick: toggleCommenting
            }]}
        >
            {enrollment.comments?.map(comment =>
                <Comment
                    key={comment.id}
                    user={user}
                    comment={comment}
                    onSave={updateComment}
                    onDelete={deleteComment}
                />
            )}

            {isCommenting &&
                <Flex
                    dir="column"
                    gap="xs"
                >
                    <Flex
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Text type="title-sm">Новый комментарий</Text>

                    </Flex>

                    <CommentForm
                        id="comment-form"
                        onSubmit={createComment}
                    />

                    <Flex
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Button
                            content="Отменить"
                            variant="plain"
                            onClick={toggleCommenting}
                        />

                        <Button
                            type="submit"
                            form="comment-form"
                            content="Отправить"
                        />
                    </Flex>
                </Flex>
            }
        </PageSection>
    );
}